import React, { useEffect, useState } from 'react';
import { MainHead } from '../Common/MainHead'
import { ApiCall, setFocus } from '../Common/utils'
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { CheckCircle, Shield, Clock, Users, Building, Briefcase, Search, AlertTriangle, Star, Phone, Mail, MapPin, ChevronDown, ChevronUp } from 'lucide-react';
import { FaqSchema, Howschema, Servicetype } from './Schema';

function TrademarkSearch() {

    const [trademarkCheck, setTrademarkCheck] = useState({
        fullName: '',
        emailID: '',
        phoneNo: '',
        companyName: '',
        brandNameToCheck: '',
        uploadlogo: '',
        serviceNeeded: ''
    })
    const [loader, setLoader] = useState(false)
    const navigate = useNavigate()


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTrademarkCheck((previous) => ({
            ...previous,
            [name]: value // ✅ This updates the right field
        }));
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                setTrademarkCheck(prev => ({
                    ...prev,
                    uploadlogo: reader.result // Base64 string
                }));
            };

            reader.readAsDataURL(file); // Converts to base64
        }
    };

    const handleTrandMarkSubmit = async (e) => {
        //const { fullName, emailID, phoneNo, companyName, brandNameToCheck, uploadlogo, serviceNeeded } = trademarkCheck;
        if (trademarkCheck.fullName.trim() === '') {
            toast.error('please enter full name .')
            setFocus('txtname')
            return
        }
        else if (trademarkCheck.emailID.trim() === '') {
            toast.error('please enter email ID .')
            setFocus('txtemail')
            return
        }
        else if (trademarkCheck.brandNameToCheck.trim() === '') {
            toast.error('please enter brand name to check .')
            setFocus('txtbrandName')
            return
        }
        else {
            try {
                setLoader(true)
                const res = await ApiCall("/api/Web/TrademarkCheck", trademarkCheck)
                if (res.status === "SUCCESS") {
                    debugger
                    setLoader(false)
                    toast.success(res.message)
                    handleReset()
                    navigate(`/thankyou?email=${trademarkCheck.emailID}`)
                }
                else if (res.status === "ERROR") {
                    setLoader(false)
                    toast.error(res.message)
                }
            } catch (error) {
                toast.error('Some error occured, Please try again later!!');
                setLoader(false)
            } finally {
                setLoader(false)
            }
        }
    }



    const handleReset = () => {
        setTrademarkCheck(prev => ({
            ...prev,
            fullName: '',
            emailID: '',
            phoneNo: '',
            companyName: '',
            brandNameToCheck: '',
            uploadlogo: '',
            serviceNeeded: ''

        }))
    }

    //useEffect(() => {
    //    setFocus('txtname')
    //}, [])


    const faqData = [
        {
            question: "What is a Trademark Search?",
            answer: "A trademark search is a comprehensive review of existing trademark databases to determine if your desired brand name, logo, or tagline is already registered or in use by another entity."
        },
        {
            question: "Why do I need a trademark search before building my brand?",
            answer: "Conducting a trademark search before investing in branding, websites, and marketing helps you avoid legal complications, costly rebranding, and potential trademark infringement issues."
        },
        {
            question: "How long does the trademark search process take?",
            answer: "Our preliminary trademark search typically takes 2-3 business days. We'll provide you with a comprehensive report on the availability of your brand name."
        },
        {
            question: "What happens if my brand name is already taken?",
            answer: "If your desired brand name is already registered, we'll provide alternative suggestions and help you develop a unique, legally available brand identity."
        },
        {
            question: "Is the preliminary search legally binding?",
            answer: "Our preliminary search provides valuable insights, but for complete legal protection, we recommend consulting with a trademark attorney for a comprehensive search and registration process."
        }
    ];

    const industries = [
        { name: 'Technology', icon: '💻' },
        { name: 'Healthcare', icon: '🏥' },
        { name: 'Finance', icon: '💰' },
        { name: 'Retail', icon: '🛍️' },
        { name: 'Education', icon: '🎓' },
        { name: 'Manufacturing', icon: '🏭' },
        { name: 'Real Estate', icon: '🏠' },
        { name: 'Food & Beverage', icon: '🍽️' },
        { name: 'Legal Services', icon: '⚖️' },
        { name: 'Consulting', icon: '📊' },
        { name: 'Media', icon: '📺' },
        { name: 'Transportation', icon: '🚛' }
    ];

    return (
        <>
            <Helmet>
                <title> Free Trademark Search for Startup in India | Website Drona</title>
                <meta name='description' content='Secure your brand with Website Drona’s free trademark search in India. Check the availability of your name, logo, or slogan before launching your business.' />
                <link rel="canonical" href="https://www.websitedrona.com/free-trademark-search-startups" />

                <meta property="og:title" content="Free Trademark Search for Startup in India | Website Drona" />
                <meta property="og: description" content="Secure your brand with Website Drona’s free trademark search in India. Check the availability of your name, logo, or slogan before launching your business.." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.websitedrona.com/free-trademark-search-startups" />
                <meta property="og:image" content="https://websitedrona.com/images/logo.png" />


                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@Website Drona" />
                <meta name="twitter:title" content="Free Trademark Search for Startup in India | Website Drona" />
                <meta name="twitter:description" content="Secure your brand with Website Drona’s free trademark search in India. Check the availability of your name, logo, or slogan before launching your business." />
                <meta name="twitter:image" content="https://www.websitedrona.com/images/trademark_form.webp" />

            </Helmet>
            <div className="trademark">
                {/* Hero Section */}
                <section className="hero-section position-relative text-white py-2">
                    <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100"></div>
                    <div className="container position-relative py-5">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="d-flex align-items-center mb-4">
                                    <CheckCircle className="me-3 text-theme" size={32} />
                                    <span className="fs-5 fw-semibold text-theme">Launch Smart</span>
                                </div>
                                <h1 className="display-3 fw-bold mb-4 lh-1">
                                    Get a Free <span className='text-theme'>Trademark Check</span> Before You Build Your Brand!
                                </h1>
                                <p className="fs-5 text-light mb-5 lh-base">
                                    Are you about to build your dream website or start digital marketing for your new brand?
                                    Don't risk costly rebranding — secure your brand identity first with our complimentary trademark search.
                                </p>
                                <div className="d-flex flex-column flex-sm-row gap-3">
                                    <button
                                        onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                                        className="btn text-white btn-lg fw-semibold px-4 py-3 cta-button"
                                    >
                                        Get Your Free TM Check Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Warning Section */}
                <section className="py-5 bg-danger-subtle border-start border-danger border-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex align-items-start">
                                    <AlertTriangle className="text-danger me-4 mt-1 flex-shrink-0" size={32} />
                                    <div>
                                        <h2 className="h2 fw-bold text-danger mb-4">Don't Risk It. Start with a Complimentary TM Search!</h2>
                                        <p className="fs-5 text-danger-emphasis lh-base">
                                            Many startups and business owners invest heavily in branding, websites, and <Link to='/digital-marketing-services-in-india'>online marketing</Link> — only to discover they don't legally own the name they're promoting. This leads to costly rebranding, domain changes, loss of brand trust, and even legal trouble.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Benefits Section */}
                <section id="benefits" className="py-5 graybg">
                    <div className="container py-5">
                        <div className="text-center mb-5">
                            <h2 className="display-4 fw-bold mb-4">Key Benefits of Our Trademark Search Service</h2>
                            <p className="fs-5 text-muted">
                                Protect your investment and build your brand with confidence
                            </p>
                        </div>

                        <div className="row g-4">
                            <div className="col-md-6 col-lg-4">
                                <div className="card h-100 shadow-sm border-0 benefit-card">
                                    <div className="card-body p-4">
                                        <div className="bg-success-subtle rounded-3 d-inline-flex p-3 mb-4">
                                            <CheckCircle className="text-success" size={32} />
                                        </div>
                                        <h3 className="h4 fw-bold text-dark mb-3">Brand Name Verification</h3>
                                        <p className="text-muted lh-base">
                                            Check if your brand name, logo, or tagline is already registered and avoid future legal complications.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4">
                                <div className="card h-100 shadow-sm border-0 benefit-card">
                                    <div className="card-body p-4">
                                        <div className="bg-primary-subtle rounded-3 d-inline-flex p-3 mb-4">
                                            <Shield className="text-primary" size={32} />
                                        </div>
                                        <h3 className="h4 fw-bold text-dark mb-3">Legal Protection</h3>
                                        <p className="text-muted lh-base">
                                            Avoid legal complications and future rebranding costs by securing your brand identity early.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4">
                                <div className="card h-100 shadow-sm border-0 benefit-card">
                                    <div className="card-body p-4">
                                        <div className="bg-warning-subtle rounded-3 d-inline-flex p-3 mb-4">
                                            <Clock className="text-warning" size={32} />
                                        </div>
                                        <h3 className="h4 fw-bold text-dark mb-3">Save Time & Money</h3>
                                        <p className="text-muted lh-base">
                                            Save time, money, and your brand's credibility by getting it right from the start.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Target Audience Section */}
                <section className="py-5">
                    <div className="container py-5">
                        <div className="text-center mb-5">
                            <h2 className="display-4 fw-bold mb-4">Who Is This For?</h2>
                            <p className="fs-5 text-muted">Perfect for forward-thinking businesses and entrepreneurs</p>
                        </div>

                        <div className="row g-4">
                            <div className="col-md-4 text-center">
                                <div className="bg-primary-subtle rounded-circle d-inline-flex p-4 mb-4">
                                    <Users className="text-primary" size={40} />
                                </div>
                                <h3 className="h4 fw-bold mb-3">New Startups</h3>
                                <p className="text-muted">
                                    Planning to launch a product or service and need to secure your brand identity.
                                </p>
                            </div>

                            <div className="col-md-4 text-center">
                                <div className="bg-success-subtle rounded-circle d-inline-flex p-4 mb-4">
                                    <Building className="text-success" size={40} />
                                </div>
                                <h3 className="h4 fw-bold mb-3">Business Owners</h3>
                                <p className="text-muted">
                                    Rebranding or taking your existing business online with confidence.
                                </p>
                            </div>

                            <div className="col-md-4 text-center">
                                <div className="bg-info-subtle rounded-circle d-inline-flex p-4 mb-4">
                                    <Briefcase className="text-info" size={40} />
                                </div>
                                <h3 className="h4 fw-bold mb-3">Serious Entrepreneurs</h3>
                                <p className="text-muted">
                                    Anyone serious about building a future-proof digital identity.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* How It Works Section */}
                <section className="py-5 graybg">
                    <div className="container py-5">
                        <div className="text-center mb-5">
                            <h2 className="display-4 fw-bold mb-4">How It Works</h2>
                            <p className="fs-5 text-muted">Simple, fast, and comprehensive</p>
                        </div>

                        <div className="row g-4">
                            <div className="col-md-4 text-center position-relative">
                                <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 step-number">
                                    <span className="fs-3 fw-bold text-white">1</span>
                                </div>
                                <h3 className="h4 fw-bold mb-3">Share Your Brand Details</h3>
                                <p className="text-muted">
                                    Provide your brand name, logo idea, and any specific details about your business.
                                </p>
                            </div>

                            <div className="col-md-4 text-center position-relative">
                                <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 step-number">
                                    <span className="fs-3 fw-bold text-white">2</span>
                                </div>
                                <h3 className="h4 fw-bold mb-3">We Run the Search</h3>
                                <p className="text-muted">
                                    Our experts conduct a comprehensive trademark availability check across relevant databases.
                                </p>
                            </div>

                            <div className="col-md-4 text-center">
                                <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 step-number">
                                    <span className="fs-3 fw-bold text-white">3</span>
                                </div>
                                <h3 className="h4 fw-bold mb-3">Get Clear Results</h3>
                                <p className="text-muted">
                                    Receive a detailed report with clear recommendations before investing in design or marketing.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Why Us Section */}
                <section className="py-5 bg-dark text-white">
                    <div className="container py-5">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-6">
                                <h2 className="display-4 fw-bold mb-4">Why Choose Website Drona?</h2>
                                <p className="fs-5 text-light mb-5 lh-base">
                                    We're not just developers and marketers — we're your brand launch partners.
                                    We believe in building strong foundations, and that starts with a secure and ownable brand identity.
                                </p>
                                <div className="vstack gap-3">
                                    <div className="d-flex align-items-center">
                                        <Star className="text-warning me-3 flex-shrink-0" size={24} />
                                        <span className="fs-5 text-white">15+ Years of Experience</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <CheckCircle className="text-success me-3 flex-shrink-0" size={24} />
                                        <span className="fs-5 text-white">Comprehensive Database Search</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Shield className="text-info me-3 flex-shrink-0" size={24} />
                                        <span className="fs-5 text-white">Legal Expertise & Guidance</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Clock className="text-warning me-3 flex-shrink-0" size={24} />
                                        <span className="fs-5 text-white">Fast 2-3 Day Turnaround</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="card border-0 p-4" style={{ backgroundColor: '#222a36' }}>
                                    <div className="card-body">
                                        <h3 className="h3 fw-bold mb-4">Ready to Build a Brand That Lasts?</h3>
                                        <p className="text-light mb-4">
                                            Start with a free TM check and let's build your digital presence the right way.
                                        </p>
                                        <button
                                            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                                            className="btn btn-warning btn-lg fw-semibold w-100 py-3"
                                        >
                                            Get Your Free TM Check Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                {/* <section id="faq" className="py-5 bg-white">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center mb-5">
                <h2 className="display-4 fw-bold text-dark mb-4">Frequently Asked Questions</h2>
                <p className="fs-5 text-muted">Everything you need to know about trademark searches</p>
              </div>

              <div className="accordion" id="faqAccordion">
                {faqData.map((faq, index) => (
                  <div key={index} className="accordion-item border rounded-3 mb-3">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed fw-semibold"
                        type="button"
                        onClick={() => toggleAccordion(index)}
                        aria-expanded={activeAccordion === index}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div className={`accordion-collapse collapse ${activeAccordion === index ? 'show' : ''}`}>
                      <div className="accordion-body">
                        <p className="text-muted mb-0 lh-base">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}

                {/* Contact Section */}
                <section id="contact" className="py-5">
                    <div className="container py-5">
                        <div className="row g-5">
                            <div className="col-lg-6">
                                <h2 className="display-4 fw-bold mb-4">Trademark Check</h2>
                                <p className="fs-5">
                                    Get your free trademark check and start building your brand with confidence.
                                </p>
                                <img src='./images/trademark_form.webp' className='w-100' />
                            </div>

                            <div className="col-lg-6">
                                <div className="card graybg border-0">
                                    <div className="card-body p-4">
                                        <div className="mb-3">
                                            <label htmlFor="name" className="form-label fw-medium">
                                                Full Name *
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                id="txtname"
                                                name="fullName"
                                                required
                                                value={trademarkCheck.fullName}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtemail")
                                                    };
                                                }}
                                                placeholder="Your Name"
                                            />
                                        </div>

                                        <div className="row g-3 mb-3">
                                            <div className="col-md-6">
                                                <label htmlFor="email" className="form-label fw-medium">
                                                    Email *
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control form-control-lg"
                                                    id="txtemail"
                                                    name="emailID"
                                                    required
                                                    value={trademarkCheck.emailID}
                                                    onChange={handleInputChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault()
                                                            setFocus("txtphone")
                                                        };
                                                    }}
                                                    placeholder="your@email.com"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="phone" className="form-label fw-medium">
                                                    Phone
                                                </label>
                                                <input
                                                    type="tel"
                                                    className="form-control form-control-lg"
                                                    id="txtphone"
                                                    name="phoneNo"
                                                    value={trademarkCheck.phoneNo}
                                                    onChange={handleInputChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault()
                                                            setFocus("txtcompany")
                                                        };
                                                    }}
                                                    placeholder="+91 00000 00000"
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="company" className="form-label fw-medium">
                                                Company Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                id="txtcompany"
                                                name="companyName"
                                                value={trademarkCheck.companyName}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtbrandName")
                                                    };
                                                }}
                                                placeholder="Your Company"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="brandName" className="form-label fw-medium">
                                                Brand Name to Check *
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                id="txtbrandName"
                                                name="brandNameToCheck"
                                                required
                                                value={trademarkCheck.brandNameToCheck}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("brandLogo")
                                                    };
                                                }}
                                                placeholder="Your Brand Name"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="brandLogo" className="form-label fw-medium">
                                                Upload Your Logo
                                            </label>
                                            <input
                                                type="file"
                                                className="form-control form-control-lg"
                                                id="brandLogo"
                                                name="Uploadlogo"
                                                onChange={handleFileChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("ddlservice")
                                                    };
                                                }}
                                            />
                                        </div>

                                        <div className="mb-4">
                                            <label htmlFor="service" className="form-label fw-medium">
                                                Service Needed
                                            </label>
                                            <select
                                                className="form-select form-select-lg"
                                                id="ddlservice"
                                                name="serviceNeeded"
                                                value={trademarkCheck.serviceNeeded}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleTrandMarkSubmit(e)
                                                    };
                                                }}
                                            >
                                                <option value="trademark-search">Free Trademark Search</option>
                                                <option value="brand-development">Brand Development</option>
                                                <option value="web-development">Web Development</option>
                                                <option value="digital-marketing">Digital Marketing</option>
                                                <option value="full-package">Complete Brand Package</option>
                                            </select>
                                        </div>

                                        <button
                                            type="submit"
                                            className="btn btn-warning btn-lg fw-semibold w-100 py-3 mb-3"

                                            onClick={(e) => handleTrandMarkSubmit(e)}
                                        >
                                            Get My Free Trademark Check
                                        </button>

                                        <p className="small text-muted text-center mb-0">
                                            By submitting this form, you agree to our privacy policy. We'll never share your information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            {/* schema  */}

            <FaqSchema />

            <Servicetype />

            <Howschema />

        </>
    );
}

export default TrademarkSearch;


